import { FadeIn } from "@/components/Reveal";

export const PolicyLayout = ({ overline, title, updated, notice, children, testid }) => (
  <div data-testid={testid}>
    <section className="pt-40 pb-16 md:pt-48 md:pb-20 border-b border-black/10 grain relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <FadeIn>
          <p className="text-xs md:text-sm uppercase tracking-[0.25em] font-semibold text-mutedblue">
            {overline}
          </p>
          <h1 className="mt-6 font-serif text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-tight max-w-3xl">
            {title}
          </h1>
          {updated && (
            <p className="mt-6 text-sm text-charcoal/60">Effective date: {updated}</p>
          )}
        </FadeIn>
      </div>
    </section>

    <section className="py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        {notice && (
          <FadeIn>
            <div
              className="mb-14 border-l-2 border-mutedblue bg-white p-6 md:p-8"
              data-testid={`${testid}-confirmation-notice`}
            >
              <p className="text-xs uppercase tracking-[0.2em] font-semibold text-mutedblue">
                To confirm before publication
              </p>
              <ul className="mt-4 space-y-2 text-sm text-charcoal/75 leading-relaxed list-disc pl-5">
                {notice.map((n) => (
                  <li key={n}>{n}</li>
                ))}
              </ul>
            </div>
          </FadeIn>
        )}
        <div className="space-y-14">{children}</div>
      </div>
    </section>
  </div>
);

export const PolicySection = ({ title, children, testid }) => (
  <FadeIn>
    <section data-testid={testid}>
      <h2 className="font-serif text-2xl md:text-3xl tracking-tight">{title}</h2>
      <div className="mt-5 space-y-4 text-sm md:text-base text-charcoal/75 leading-relaxed">
        {children}
      </div>
    </section>
  </FadeIn>
);
